import Icon from '../icon'

export default {
  name: 'KBreadcrumbItem',
  inject: ['breadcrumb'],
  props: {
    to: { // 路由信息
      type: Object,
      // null
      default() {
        return null
      },
    },
    replace: { // 当使用路由时，不会向 history 添加新纪录
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  watch: {},
  computed: {
    separator() {
      if (this.breadcrumb.separatorIcon) {
        return {
          name: this.breadcrumb.separatorIcon,
          icon: true,
        }
      }
      return {
        name: this.breadcrumb.separator,
        icon: false,
      }
    },
  },
  created() {
  },
  methods: {
    renderSeparator() {
      return (
        <span
          class="km-breadcrumb__separator"
        >
          {
            this.separator.icon
              ? <Icon name={this.separator.name}></Icon>
              : this.separator.name
          }
        </span>
      )
    },
  },
  render() {
    const style = {}

    const css = {
      'km-breadcrumb__item': true,
    }

    const attrs = {}

    const props = {}

    const events = {}

    if (this.to) {
      props.to = this.to
      props.replace = this.replace
    }

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      props: props,
      on: events,
    }

    return (
      <li
        {...data}>
        {this.to
          ? <router-link
            to={this.to}
            replace={this.replace}
          >
            {this.$slots.default}
          </router-link>
          : this.$slots.default
        }
        {this.renderSeparator()}
      </li>
    )
  },
}
